import {iSolemnlySwearThisHtmlIsClean} from '../../../../libs/shared/core/src/helpers/typescript/cleanHtml';

// Attribute names for answer variables in the composer body html.
export const answerVariablePluginDataAttribute = 'data-front-decoration-variable';
export const answerVariablePluginTopicIdAttribute = 'data-front-decoration-variable-topic-id';

// This variable is interpolated on the backend.
//
// This is not declared in `survey.ts` because that module imports an image
// asset, which is not allowed on mobile.
export const surveyTemplateVariable = iSolemnlySwearThisHtmlIsClean('{{survey}}');
